import { ActionFunction, redirect } from 'react-router-dom';

// Sentry
import * as Sentry from '@sentry/react';

// Store
import { passData } from './ActionUtils/passData';
import { saveData } from './ActionUtils/saveData';
import { showSuccessToast } from '../../../../../utils/toasts';
import i18n from '../../../../../i18n';

function isOfflineQueuedError(err: unknown): boolean {
  const e = err as {
    offlineQueued?: boolean;
    message?: string;
    networkError?: { offlineQueued?: boolean };
  };
  return (
    e?.offlineQueued === true ||
    e?.networkError?.offlineQueued === true ||
    (e?.message ?? '').includes('Mutation queued for offline sync')
  );
}

export const ActionEditCampaignSummary: ActionFunction = async ({
  request,
  params,
}) => {
  const formData = await request.formData();
  const intent = formData.get('intent');

  if (intent === 'pass-data') {
    try {
      return passData({
        formData,
      });
    } catch (err) {
      Sentry.captureException(err);
      console.log('Error:', err);
    }
  }

  if (intent === 'save-data') {
    try {
      return await saveData({
        formData,
        urlCampaignId: params.id,
      });
    } catch (err) {
      // Bloque C-7.5: si SAVE_CAMPAIGN (update path) se encoló offline,
      // redirigimos a la lista de campañas sin propagar a ErrorPage. Al
      // reconectar, syncOfflineQueue replay-ea la mutation con el id en input.
      if (isOfflineQueuedError(err)) {
        showSuccessToast(i18n.t('modals:changeState.queuedOffline'));
        window.dispatchEvent(new CustomEvent('offline-campaign-queued'));
        // A la campaña editada, no al listado: con red el guardado vuelve a
        // `../../{id}`, y encolar no debería cambiar a dónde aterrizas.
        const campaignId = formData.get('id');
        return redirect(
          campaignId ? `/work-orders/campaign/${campaignId}` : '/work-orders/campaign',
        );
      }
      Sentry.captureException(err);
      console.log('> Campaign summary - error updating:', err);
      // Re-lanzar → errorElement. Antes: `return null` silencioso.
      throw err;
    }
  }
  return null;
};
